export default __webpack_public_path__ + "static/media/ldo_FLOAT_ADJ_nEN_nCff.c41dc7c9.svg";